import { cn } from "@utils/tw"
import { useHydrating } from "eddev/routing"
import { useEffect, useState } from "react"

type Props = {
  lines: string[]
  interval?: number
  className?: string
  index?: number
}

export function CycleText(props: Props) {
  const [currentLine, setCurrentLine] = useState(0)
  const [previousLine, setPreviousLine] = useState(-1)

  useEffect(() => {
    if (typeof props.index === "number") {
      setCurrentLine(props.index % props.lines.length)
      setPreviousLine((props.index - 1 + props.lines.length) % props.lines.length)
      return
    }
    if (!props.lines || props.lines.length === 0) return
    const interval = setInterval(() => {
      setCurrentLine((prev) => {
        setPreviousLine(prev)
        return (prev + 1) % props.lines!.length
      })
    }, props.interval ?? 3000)
    return () => clearInterval(interval)
  }, [props.interval, props.index, props.lines.join(",")])

  return (
    <div className={cn(props.className, "relative h-[1em]")}>
      {props.lines?.map(
        (line, index) =>
          !!line && (
            <span
              key={index}
              className={cn(
                "block absolute leading-none left-0 top-0 w-full transition-[opacity,transform] duration-500 opacity-0 translate-y-4",
                index === currentLine && "opacity-100 translate-y-0",
                index === previousLine && "-translate-y-4",
              )}
            >
              {line}
            </span>
          ),
      )}
    </div>
  )
}
